import { markRaw } from "vue";
import { BaseElementDef, BaseElementDefBase, IBlockSubmitElement, ICustomConfirmElement, IShouldSkipConfirmElement } from "./BaseElementDef";
import { map } from "rxjs/operators";
import { FormDefinitionItem } from "./__DefinitionDataInterface";
import { CaptchaControlSettings } from "@cs-ts/captcha-control-settings";
import { CalculationContext } from "./__CalculationContextInterface";
import type CaptchaBehaviorDef from "./CaptchaBehaviorDef";
import { BehaviorSubject, from } from "rxjs";
import type { FormCaptchaItem } from "./CaptchaBehaviorDef";

export default class CaptchaControlDef extends BaseElementDef<CaptchaControlSettings, FormDefinitionItem<CaptchaControlSettings>, FormCaptchaItem> implements IShouldSkipConfirmElement, IBlockSubmitElement, ICustomConfirmElement {
    captchaToken: string | null;
    hasCaptchaToken$: BehaviorSubject<boolean>;

    constructor(parentElement: BaseElementDefBase | null, elementData: FormCaptchaItem, definitionData: FormDefinitionItem<CaptchaControlSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.captchaToken = null;
        this.hasCaptchaToken$ = new BehaviorSubject<boolean>(false);
    }

    shouldSkipConfirm() {
        return false;
    }

    shouldSkipConfirm$() {
        return from([false]);
    }

    hasCustomConfirmComponent(adminPreview: boolean) {
        return !adminPreview;
    }

    isSegment(segment: string | null) {
        return segment == null || segment == this.definition.settings.segment;
    }

    async setCaptchaToken(token: string) {
        this.captchaToken = token;
        const behaviorId = (this.id as string).replace("_Control", "");
        for (const behavior of (await this.getRoot().getElementsById$(behaviorId!).toPromise())!) {
            (behavior as CaptchaBehaviorDef).setCaptchaToken(token);
        }
        this.hasCaptchaToken$.next(true);
    }

    getData(excludeChildren?: boolean) {
        const result = super.getData(excludeChildren) as FormCaptchaItem;
        if (result != null && this.captchaToken != null) {
            result.captchaToken = this.captchaToken;
        }
        return result;
    }

    blockSubmit$() {
        return this.hasCaptchaToken$.pipe(map(i => !i));
    }

    async getCustomConfirmComponent(adminPreview: boolean) {
        const component = markRaw((await import(/* webpackChunkName: "PageAdmin" */ "./CaptchaConfirm.3.vue")).default);
        return {
            component,
            data: {
                callback: (token: string) => this.setCaptchaToken(token),
            },
        };
    }
}
